module.exports = __webpack_public_path__ + "static/media/weather.9a5bb6a4.png";